import React, { Component, PureComponent } from "react";
import "./editor-map.css";
import i18n from "i18next";

import DOMPurify from "dompurify";

export default class Map extends Component {
  static whyDidYouRender = true;
  isSmallScreen = true;

  constructor(props) {
    super(props);
    this._poster = React.createRef();
    this._posterWrapper = React.createRef();
    this._content = React.createRef();
    this._map = React.createRef();

    this.state = {
      posterWidth: "-1",
      posterHeight: "-1",
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    console.log("Calculating window size");
    let windowWidth = window.innerWidth;
    let isSmallScreen = windowWidth < 768 ? true : false;
    this.isSmallScreen = isSmallScreen;

    this.updatePosterSize(this.props.ratio);
    //var styleWidth = width === -1 ? "auto" : `${width}px`;
    //var styleHeight = height === -1 ? "auto" : `${height}px`;

    //this._posterWrapper.current.style.width = styleWidth;
    //this._posterWrapper.current.style.height = styleHeight;
  };

  updatePosterSize = (ratio) => {
    var margin = 2 * 20;
    if (!this.isSmallScreen) {
      margin = 2 * 100;
    }
    var maxWidth = this._content.current.offsetWidth - margin;
    var maxHeight = this._content.current.offsetHeight - margin;
    var ratioSplit = ratio.split("-");
    var ratioX = parseInt(ratioSplit[0]);
    var ratioY = parseInt(ratioSplit[1]);
    var width = -1;
    var height = -1;
    var tempHeight = (maxWidth * ratioX) / ratioY;
    if (tempHeight > maxHeight) {
      width = (maxHeight * ratioY) / ratioX;
    } else {
      height = tempHeight;
    }

    this.setState({
      posterWidth: width,
      posterHeight: height,
    });
  };

  getFixedText1(text1) {
    if (text1) {
      try {
        return DOMPurify.sanitize(text1).replace(
          /❤️/g,
          '<i class="fa fa-heart"></i>'
        );
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    }
    return "";
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      text1: this.getFixedText1(nextProps.text1),
    });

    if (nextProps.ratio !== this.props.ratio) {
      this.updatePosterSize(nextProps.ratio);
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (
  //     nextProps.text1 !== this.props.text1 ||
  //     nextProps.text2 !== this.props.text2 ||
  //     nextProps.ratio !== this.props.ratio ||
  //     nextProps.styleId !== this.props.styleId
  //   ) {
  //     console.log("map should update!");
  //     return true;
  //   } else {
  //     console.log("map shouldn't update");
  //     return false;
  //   }
  // }

  render() {
    console.log("Rendering editor-map");
    return (
      <div
        class="content text-center d-flex flex-column flex-grow-1 align-items-stretch justify-content-start"
        ref={this._content}
      >
        {/* загрузка шрифта */}
        <div
          style={{
            height: 0,
            width: 0,
            overflow: "hidden",
          }}
        >
          <span style={{ fontFamily: "Caveat", fontSize: "0px" }}>
            font завантаження...
          </span>
        </div>
        <div class="g-pt-5 g-px-5 g-top-0">
          <div class="text-center">
            <p class="g-mt-0 g-mb-0 g-font-size-10 g-font-size-12--lg">
              <i class="fa fa-info-circle"></i> Фінальне зображеня буде створено
              на основі запису вашого голосу, який можна буде відправити після
              оформлення замовлення
            </p>
          </div>
        </div>
        <div class="d-flex flex-grow-1 justify-content-center align-items-center">
          <div
            class={
              " poster-wrapper audio" +
              " horizontal ratio-" +
              this.props.ratio +
              (this.state.posterHeight == -1 ? " align-self-stretch" : "") +
              (this.state.posterWidth == -1 ? " flex-grow-1" : "")
            }
            style={{
              height:
                this.state.posterHeight != -1
                  ? this.state.posterHeight
                  : "auto",
              width:
                this.state.posterWidth != -1 ? this.state.posterWidth : "auto",
            }}
            ref={this._posterWrapper}
          >
            <div
              class={"u-shadow-v1-5 poster audio " + this.props.styleId}
              ref={this._poster}
            >
              <div class="poster-inner-border audio position-relative">
                <div class="poster-inner d-flex flex-column justify-content-around align-items-center">
                  <div class="poster-text1 horizontal ">
                    <p
                      dangerouslySetInnerHTML={{ __html: this.state.text1 }}
                    ></p>
                  </div>
                  {/* <div class=" "> */}
                  <div
                    class=" d-flex align-self-stretch  align-items-center justify-content-center"
                    style={{ height: "70%" }}
                  >
                    <img
                      class="img-fluid "
                      style={{ maxHeight: "100%" }}
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/img/audio/waveform_" +
                        this.props.styleId +
                        ".png"
                      }
                    ></img>
                  </div>

                  {/* </div> */}

                  <div class="poster-text2 horizontal ">
                    <p>{this.props.text2}</p>
                  </div>
                </div>
                <img
                  class="img-fluid position-absolute g-bottom-10 g-right-10"
                  style={{ height: "5%" }}
                  src={process.env.PUBLIC_URL + "/assets/img/audio/qr-code.png"}
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
